import { Box, Button, Tooltip, Typography } from "@mui/material"
import { exportClientMycas, getClientMycas, getIncomeTaxProfile } from "api/services/automation/income-tax";
import Table, { ColumnType } from "components/Table";
import { useMutation, useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { ResType } from "types";
import { useState } from "react";
import AccessDenied from "./Access/accessDenide";
import Loader from "components/Loader";
import { formatToRupeess } from "utils/formattedAmount";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import moment from "moment";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { getCurrentFormattedDateTime } from "utils";
import { snack } from "components/toast";
import { handleError } from "utils/handleError";
import sortHandler from "components/Table/SortHandler";
import _ from "lodash";
import { SortDirection } from "data/constants";


const ClientMycas = (state) => {
  const params = useParams();
  const navigate = useNavigate()
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [checkAccess, setCheckAccess] = useState(true)
  const [sort, setSort] = useState<any>({});

  const { data, isLoading }: ResType = useQuery(
    ["get-client-my-cas", params.incometaxid, { limit: pageCount, offset: page * pageCount,sort, }],
    getClientMycas,
    {
      onSuccess: (res) => {
        setCheckAccess(res?.data?.accessDenied)
        setTotalCount(res?.data?.count);
      },
    }
  );



  const defaultColumns: Array<ColumnType> = [
    {
      key: "id",
      title: "AY",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return (
          <Box>
            <Typography>{row?.assessmentYear ? `${row?.assessmentYear}` : ""}</Typography>
          </Box>
        );
      },
    },
    {
      key: "caName",
      title: "CA Name",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
    },
    {
      key: "caMembershipNum",
      title: "Membership #",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return (
          <Box>
            <Typography>{row?.caMembershipNum ? `${row?.caMembershipNum}` : "-"}</Typography>
          </Box>
        );
      },
    },
    {
      key: "filingType",
      title: "Filing Type",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return (
          <Typography>
            {row?.filingType === 'O'
              ? 'Original'
              : row?.filingType === 'R'
                ? 'Revised'
                : '-'}
          </Typography>
        )
      }
    },
    {
      key: "formTypeCd",
      title: "Form Type",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
    },
    {
      key: "assignedDate",
      title: "Assigned Date",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return (
          <Typography>
            {row?.assignedDate ? moment(row?.assignedDate).format("MMM DD, YYYY") : "-"}
          </Typography>
        );
      },
    },
    {
      key: "transactionNo",
      title: "Transaction ID",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
    },

    {
      key: "udinNumber",
      title: "UDIN",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return (
          <Typography>{row?.udinNumber ? row?.udinNumber : '-'}</Typography>
        )
      }
    },

  ];

  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSort,
      setColumns: setColumns,
    });
  };
  
  const { data: profiledata, isLoading: isprofileloading }: ResType = useQuery(
    ["get-income-tax-profile", params.incometaxid],
    getIncomeTaxProfile,
  );
  const clientName = profiledata?.data?.profileDetails?.name;
  const { mutate: mutate1 } = useMutation(exportClientMycas, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      const formattedDateTime = getCurrentFormattedDateTime();
      link.href = file;
      link.download = `ATOM Pro - ${clientName} Income Tax Authorised Representatives (CA) ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Income Tax (PAN) Authorised Representatives (CA) exported sucessfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });

  const handleExport = () => {
    mutate1({
      incometaxid: params.incometaxid,
      ...state,


    });

  }
  if (isLoading) return <Loader />
  return (
    <>
     <Box m={1}>
      {!checkAccess && (
        <AccessDenied />
      )}
      <Box display="flex" justifyContent="flex-end" sx={{ p: 1 }}>
        <Button variant="outlined" color="secondary" onClick={handleExport}
          startIcon={<FileDownloadOutlinedIcon />}>
          Export
        </Button>
      </Box>
      {checkAccess && (
        <Box>
          {data && data?.data.count > 0 ?
            <>
              <Table
                            sx={{ pb: 0, mb: 0, height: '470px' }}

                // selection={{ selected, setSelected }}
                pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
                data={data?.data?.result || []}
                columns={columns}
                sortHandler={handleSort}
                loading={isLoading}
              />
            </> : <>
              <Box textAlign="center" mt={20}>
                <Typography variant="subtitle1" color="rgba(0,0,0,0.5)">
                  No Data present
                </Typography>
              </Box>
            </>}
        </Box>
      )}
      </Box>
    </>
  )
}

export default ClientMycas